<template>
  <section>
    <div class="container">
      <h2 class="text-center mb-4 title-header">Available Jobs</h2>
      <!-- Search Filters -->
      <div class="job-filters d-flex align-items-center">
        <div class="aligment">
          <div class="form-group w-100">
            <v-select
              v-model="keywords"
              placeholder="Competencies"
              label="name"
              :options="getCompetencesFilterList"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
          </div>
          <div class="form-group w-100">
            <select v-model="employment_type" class="form-control new-control" id="Employment-type">
              <option value="3">All types of employments</option>
              <option value="1">Regular employment</option>
              <option value="2">Self-employment / Freelancing</option>
            </select>
            <label class="sr-only" for="Employment-type">Employment</label>
          </div>
        </div>
        <div class="aligment-secondary">
          <v-select
            @search="fetchOptions"
            v-model="sendLocation"
            class="mr-1 w-100 mb-3"
            label="name"
            placeholder="Location"
            aria-label="location"
            aria-describedby="location-input"
            :options="[...locationsOptions]"
            :reduce="location => location"
            :clearable="false"
            multiple
          >
            <template v-slot:no-options>
              <div style="opacity: 0.5">Please type at least 3 characters</div>
            </template>
          </v-select>
          <button @click="searchJob(1)" class="btn btn-danger w-100 m-0 mb-3">Search Jobs</button>
        </div>
      </div>
      <!-- End Search Filters -->

      <section class="latest-ads">
        <Spinner :isLoading="isLoading" />
        <div class="row">
          <!-- Left Col -->
          <div class="col-md-12">
            <!-- Single Job Post -->
            <div v-if="jobAds.length">
              <div v-for="job in jobAds" :key="job.id" class="single d-flex align-items-center">
                <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.id } }">
                  <img
                    v-if="job.anonymize"
                    :src="require(`../../../public/img/homepage/customer-logos/comstream-logo.png`)"
                    :alt="job.title"
                  />
                  <span v-else>
                    <img
                      v-if="
                        job.employer_photo !== null &&
                          job.employer_photo !== 'default.png' &&
                          job.employer_photo !== 'null' &&
                          job.employer_photo !== ''
                      "
                      :src="`https://jobshark.eu/storage/employers/logos/${job.employer_photo}`"
                      :alt="job.title"
                    />
                    <img
                      v-else
                      :src="require(`../../../public/img/comstream.svg`)"
                      :alt="job.title"
                    />
                  </span>
                </router-link>
                <div class="job-info">
                  <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.id } }">{{
                    job.title
                  }}</router-link>
                  <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.id } }">{{
                    job.employer_name
                  }}</router-link>
                </div>
                <div
                  v-if="job && job.address && job.address.city && job.address.country"
                  class="location"
                >
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ job.address.city.name }}</span>
                  <span>{{ job.address.country.name }}</span>
                </div>
                <div class="location">
                  <i class="fas fa-handshake"></i>
                  <span>{{ employmentType(job.employment_type) }}</span>
                </div>
                <div class="location">
                  <i class="fas fa-briefcase"></i>
                  <span>{{ showWorkPlace(job.workplace) }}</span>
                </div>
                <div v-if="job.required_competences.length > 0" class="tagline ml-auto">
                  <a v-for="competence in job.required_competences" :key="competence.id" href="#">{{
                    competence.name
                  }}</a>
                </div>
                <div v-else class="tagline ml-auto"></div>
              </div>
              <!-- End Single Job Post -->
            </div>
            <div style="margin-top: 20px; text-align: center" v-else>
              <h2>No jobs found with current filters</h2>
            </div>
          </div>
          <!-- End Left Col -->
        </div>
      </section>

      <span class="d-flex bottom-controls">
        <div class="mx-auto">
          <Pagination
            v-show="!isLoading"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @nextPage="nextPage"
            @prevPage="previousPage"
            @selectPageByNumber="setPageByNumber"
            @firstPage="setToFirstPage"
            @lastPage="setToLastPage"
            @keyup="keymonitor"
          ></Pagination>
        </div>
      </span>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from '../Navigations/Pagination';
import { errorService } from '../../services/errorService';
/* import FilePreview from '../Home/FilePreview.vue'; */
import axios from 'axios';

export default {
  data() {
    return {
      keywords: [],
      jobAds: [],
      employers: [],
      employment_type: 3,
      locations: [],
      locationsOptions: [],
      sendLocation: [],
      currentPage: 1,
      totalPages: 0,
      isLoading: true,
    };
  },
  components: {
    Pagination,
    /* FilePreview, */
  },
  methods: {
    ...mapActions([
      'fetchAllJobResults',
      'retrieveEmployersDropdownCandidate',
      'retrieveCompetencesList',
      'searchLocationByName',
    ]),
    onEmployerSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.retrieveEmployersDropdownCandidate();
        /* this.competencesOptions = this.getCompetencesFilterList; */
      }

      loading(false);
    },
    searchJob(currentPage) {
      this.isLoading = true;
      const temp = this.sendLocation.map(location => location.id);
      let empl_type = null;
      if (Number(this.employment_type) !== 3) {
        empl_type = this.employment_type;
      }
      axios(`${process.env.VUE_APP_API_URL}/candidate/search`, {
        method: 'post',
        data: {
          page: currentPage,
          count: 10,
          employers: this.employers.map(employer => employer.id),
          competences: this.keywords.map(competence => competence.id),
          employment_type: empl_type,
          locations: temp,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.isLoading = false;
          localStorage.setItem('UserSearchLocation', JSON.stringify(this.sendLocation));
          localStorage.setItem('UserSearchKeywords', JSON.stringify(this.keywords));
          localStorage.setItem('UserSearchEmployer', JSON.stringify(this.employers));
          this.currentPage = response.data.current_page;
          this.jobAds = response.data.data;
          this.totalPages = response.data.last_page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /* Pagination */
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.totalPages) {
        this.isLoading = true;
        this.currentPage++;
        this.searchJob(this.currentPage);
        localStorage.setItem('UserJobList', this.currentPage);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        //   this.isLoading = true;
        --this.currentPage;
        this.searchJob(this.currentPage);
        localStorage.setItem('UserJobList', this.currentPage);
      } else {
        this.currentPage = 1;
        this.searchJob(this.currentPage);
        localStorage.setItem('UserJobList', this.currentPage);
      }
    },
    setToFirstPage() {
      //  this.isLoading = true;
      this.currentPage = 1;
      this.searchJob(this.currentPage);
      localStorage.setItem('UserJobList', this.currentPage);
    },
    setToLastPage(lastPage) {
      //  this.isLoading = true;
      this.currentPage = lastPage;
      this.searchJob(this.currentPage);
      localStorage.setItem('UserJobList', this.currentPage);
    },
    setPageByNumber(pageNumber) {
      if (pageNumber > this.totalPages || pageNumber < 1) return;
      this.currentPage = Number(pageNumber);
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    /* End Pagination */
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    fetchOptions(search, loading) {
      console.log(search);
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.locationsOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
  },

  computed: {
    ...mapGetters([
      'allSearchJobResults',
      'getEmployersDropdownCandidate',
      'getCompetencesFilterList',
    ]),
  },
  mounted() {
    if (localStorage.getItem('UserJobList') > 1) {
      this.currentPage = localStorage.getItem('UserJobList');
    }
    if (localStorage.getItem('UserSearchLocation').length > 0) {
      this.sendLocation = JSON.parse(localStorage.getItem('UserSearchLocation'));
    }
    if (localStorage.getItem('UserSearchKeywords').length > 0) {
      this.keywords = JSON.parse(localStorage.getItem('UserSearchKeywords'));
    }
    if (localStorage.getItem('UserSearchEmployer').length > 0) {
      this.employers = JSON.parse(localStorage.getItem('UserSearchEmployer'));
    }
    this.searchJob(this.currentPage);
    this.retrieveCompetencesList();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';

.title-header {
  font-family: Montserrat, Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: bolder;
}
.applied {
  font-size: 14px;
  position: absolute; /* 2 */
  top: 50%; /* 3 */
  transform: translate(0, -50%);
  right: 0;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  text-transform: uppercase;
  i {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #28a745;
    border-radius: 50%;
    margin: 0 auto;
    color: #fff;
    width: 18px;
    height: 18px;
    margin-bottom: 3px;
  }
}
/deep/ .job-filters {
  .vs--searchable .vs__dropdown-toggle {
    height: auto;
  }
  .vs__search {
    padding-top: 2px !important;
  }

  .aligment {
    width: 62%;
  }
  .aligment-secondary {
    flex: 1;
    margin-left: 12px;
  }
  .form-control {
    color: #777;
  }
  .btn-danger {
    align-self: flex-end;
    font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #fff;
    background-color: #f26622;
    border-color: #f26622;
    margin: 0 0 16px 12px;
  }
}

.latest-ads {
  position: relative;
  padding: 20px 0;
  min-height: 55vh;
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }
  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;
    img {
      width: 70px;
      height: 70px;
      max-width: 70px;
      object-fit: contain;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .job-info {
      position: relative;
      width: 37%;
      margin-right: 12px;
      a {
        display: block;
        text-decoration: none;
        &:first-of-type {
          font-size: 18px;
        }
        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }
    .location {
      text-align: center;
      width: 130px;
      margin: 0 10px;
      a {
        text-decoration: none;
      }
      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }
    .tagline {
      text-align: right;
      width: 200px;
      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}

/* Media queries */

@media only screen and (max-width: 1251px) {
}

@media only screen and (max-width: 992px) {
  .job-filters {
    display: block !important;
    .aligment {
      width: 100%;
    }
    .aligment-secondary {
      flex: 1;
      margin-left: 0px;
    }
  }
}

@media only screen and (max-width: 576px) {
  .job-filters {
    .aligment {
      width: 100%;
    }
    .aligment-secondary {
      flex: 1;
      margin-left: 0px;
    }
  }
  .latest-ads {
    .single {
      flex-wrap: wrap;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        width: 48%;
        text-align: left;
        i {
          display: none;
        }
        &:nth-last-of-type(2) {
          text-align: right;
        }
      }
    }
  }
}
</style>
